import styled from "styled-components";

export const SlotWrapper = styled.div`
 display:flex;
 flex-direction: column;
 gap: 1rem
`;